import React, { useState, memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
    CANDIDATE_ICON,
    EMPLOYER_ICON,
    EDUCATION_ICON,
} from '../../constants/IconType';
import Utils from '../../services/UtilsService';
import companyLogoImage from '../../assets/image/company-logo.svg';
import educationLogo from '../../assets/image/education-logo.svg';
import ProfileImg from '../../assets/image/profile.svg';
import { getRandomProfileBackground } from '../candidates/profileColorSchemeUtil';

const useStyles = makeStyles({
    root: {
        '&.blurred': {
            filter: 'url("#sharpBlur")',
        },
    },
});

export const getIconByType = (type, className, testId) => {
    const background = getRandomProfileBackground();

    switch (type) {
        case CANDIDATE_ICON:
            return <img data-test-id={testId} className={className} src={ProfileImg} style={{ background }} />;
        case EMPLOYER_ICON:
            return <img data-test-id={testId} className={className} src={companyLogoImage}/>;
        case EDUCATION_ICON:
            return <img data-test-id={testId} className={className} src={educationLogo}/>;
        default:
            return null;
    }
};
const EMPTY_PHOTO_REGEX = /^https:\/\/static-exp\d+\.licdn\.com/;

// Modified by AI on 05/26/2026. Edit #1.
const IconComponent = ({
    testId = 'icon',
    url = '',
    type = '',
    className = '',
    blurred = false,
    width,
    height,
}) => {
    const styles = {
        ...(width && { width }),
        ...(height && { height }),
    };

    const classes = useStyles({ blurred });
    const rootClasses = Utils.getClassName([
        classes.root,
        className,
        blurred ? 'blurred' : '',
    ]);
    const resultTestId = `${testId}-${type}`;

    const [imageLoadFail, setImageLoadFail] = useState(false);

    if (!url || imageLoadFail || EMPTY_PHOTO_REGEX.test(url)) {
        return getIconByType(type, className, resultTestId);
    }

    return <img
        data-test-id={resultTestId}
        className={rootClasses}
        src={url}
        onError={() => setImageLoadFail(true)}
        style={styles}
    />;
};

IconComponent.propTypes = {
    testId: PropTypes.string,
    url: PropTypes.string,
    type: PropTypes.string,
    className: PropTypes.string,
    blurred: PropTypes.bool,
    width: PropTypes.number,
    height: PropTypes.number,
};

export default memo(IconComponent);
